import TGRadio from 'src/components/ui/TGRadio';
import { CheckboxUI } from 'src/pages/DashboardPage/acadia/components/Filters/CheckLists';
import { FilterOptionsProps } from '../../../types/typesVPO';

const FilterOptions = ({ options, selectedOptions, toggleOption, searchValue = '', filterType }: FilterOptionsProps) => {
  const filteredOptions = options?.filter((option) => option?.toLowerCase().includes(searchValue.toLowerCase()));
  
  const isRadioFilter =
    filterType === 'year' ||
    filterType === 'month' ||
    filterType === 'group' ||
    filterType === 'columnPlanAction' ||
    filterType === 'groupPlanAction' ||
    filterType === 'groupPlan' ||
    filterType === 'formGop' ||
    filterType === 'columnReportAction' ||
    filterType === 'locationKPI' ||
    filterType === 'kpiName' ||
    filterType === 'location5S' ||
    filterType === 'department5S'    
  if (isRadioFilter) {
    return (
      <div className='mt-3 flex flex-col gap-2'>
        {filteredOptions.map((option) => (
          <TGRadio key={option} isChecked={selectedOptions.includes(option)} onChange={() => toggleOption(option)} name={filterType}>
            <span className='text-sm font-medium text-black'>{option}</span>
          </TGRadio>
        ))}
      </div>
    );
  }

  return (
    <div className='mt-3'>
      {filteredOptions.map((option, index) => {
        const item = {
          id: option,
          title: option,
          isChecked: selectedOptions.includes(option),
        };

        return (
          <div key={option} className='flex items-center mb-2 font-medium text-sm'>
            <CheckboxUI key={item.id} item={item} index={index} onChecked={() => toggleOption(option)} isCheck={selectedOptions.includes(option)} disabled={false} />
          </div>
        );
      })}
    </div>
  );
};

export default FilterOptions;
